import {
  Bell,
  ChartNoAxesColumn,
  ShieldCheck,
  SlidersHorizontal,
  UserRound,
  type LucideIcon,
} from 'lucide-react';

export interface SettingsTab {
  id: 'profile' | 'security' | 'notifications' | 'preferences' | 'administration';
  labelKey: string;
  icon: LucideIcon;
}

export const SETTINGS_TABS: SettingsTab[] = [
  { id: 'profile', labelKey: 'settings.tabs.profile', icon: UserRound },
  { id: 'security', labelKey: 'settings.tabs.security', icon: ShieldCheck },
  { id: 'notifications', labelKey: 'settings.tabs.notifications', icon: Bell },
  { id: 'preferences', labelKey: 'settings.tabs.preferences', icon: SlidersHorizontal },
  { id: 'administration', labelKey: 'settings.tabs.administration', icon: ChartNoAxesColumn },
];
